/// <reference path="../app.ts" />
namespace Cfnc {

    interface ICfncAccountAvailable extends ng.IDirective {

    }

    interface ICfncAccountAvailableScope extends ng.IScope {
        ngModel: string;
        emailVerificationResult: EmailVerificationResult;
        test: string;
    }

    interface ICfncAccountAvailableAttributes extends ng.IAttributes {
        cfncAccountAvailable: string;
        originalValue: string;
        ngModel: string;
        test: string;
        emailVerificationResult: string;
    }

    class EmailVerificationResult {
        emailIsValid: boolean;
        emailVerified: boolean;
        emailSignature: boolean;
    }
   
    class CfncAccountAvailable implements ICfncAccountAvailable {
        static directiveId: string = "cfncAccountAvailable";
        restrict: string = "A";
        require: string = "?ngModel";
        scope: any = {
            ngModel: "=",
            emailVerificationResult: "="
        };

        private log;
        logError: (msg, data?, showToast?) => void;


        constructor(private $parse: ng.IParseService, private Restangular: Restangular.IService, private common: Cfnc.ICommonFactory) {
            this.logError = common.logger.getLogFn(CfncAccountAvailable.directiveId, "error");
        }

        link = (scope: ICfncAccountAvailableScope, element, attrs: ICfncAccountAvailableAttributes, controller: ng.INgModelController) => {
            scope.$watch("ngModel", (model: string) => {
                if (!attrs.cfncAccountAvailable) {
                    attrs.cfncAccountAvailable = "username";
                }

                this.common.debouncedThrottle("UserNameAvailibilty", () => {
                   if (attrs.originalValue) {
                        if (model === attrs.originalValue) {
                            controller.$setValidity("available", true);
                            return;
                        }
                    }
                   if (model) {
                       this.Restangular.all("users")
                           .all(model)
                           .one("check" + attrs.cfncAccountAvailable).get().then((result: EmailVerificationResult) => {
                               controller.$setValidity("available", true);
                               scope.emailVerificationResult.emailIsValid = result.emailIsValid;
                               scope.emailVerificationResult.emailVerified = result.emailVerified;
                               scope.emailVerificationResult.emailSignature = result.emailSignature;
                           }, (reason) => {
                               if (reason.status === 409) {
                                   controller.$setValidity("available", false);
                               } else {
                                   controller.$setValidity("available", true);
                                   this.logError("An error occurred while checking the availability of the provided account name or email address. Please try again later.", reason, true);
                               }
                           });
                   }
                   else {
                       controller.$setValidity("available", true);
                   }
                }, 500);
            });
        };
    }

    angular.module("app").directive(CfncAccountAvailable.directiveId, ["$parse", "Restangular", "common",
        ($parse: ng.IParseService, Restangular: Restangular.IService, common: Cfnc.ICommonFactory) =>
            new CfncAccountAvailable($parse, Restangular, common)
    ]);
}